import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import { CSSProperties } from 'react';
import { UIIframeModulesState } from './UI.Iframe';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
   
    /** 当前收起状态 */
    public collapsed: boolean = true;

    /** 菜单的样式 */
    public menuStyle: CSSProperties = {};

    /** 是否出现错误 */
    public isError: boolean = false;

    /** iframe UI 模块状态 */
    public uiIframeModulesState:UIIframeModulesState = new UIIframeModulesState();
}



// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/Modules.State.ts